import { API, API_POST } from "../../Config";

export const handleAddCoupon = (payload) => {
  const f = new FormData();

  f.append("coupon_code", payload.coupon_code);
  f.append("description", payload.description);
  f.append("discount_type", payload.discount_type);
  f.append("discount_value", payload.discount_value);

  return API_POST(API.AddCoupon, f);
};
